



















import {Component, Vue} from '@/shared/component';
import {Stored} from "vue-stored-prop-decorator";
import {ResultType} from "@/shared/xhttp";

import storeUser from '@/stores/modules/user';
import {Emit} from "vue-property-decorator";

@Component({
	components: {
	}
})
export default class HomeView extends Vue {

	
	public mounted(): void {
		this.addEventDom(window, 'resize', () => this.$forceUpdate());
	}

}
